/**
**  项目管理---项目详情-项目历史界面
 */
<template>
  <div id="ProjectHistory" class="jc-page">
    <div class="jc-panel jc-page-head">
			<span class="header-title">
        <el-page-header @back="goBack" :content=headerTitle></el-page-header>
      </span>
		</div>
    <div class="jc-table-container jc-scroll-panel">
      <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="checkup_subject_name" label="检查表名称" min-width="180">
          </el-table-column>

              <el-table-column prop="start_date" label="开始时间" min-width="180">
          </el-table-column>

              <el-table-column prop="end_date" label="结束时间" min-width="180">
          </el-table-column>

          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="handleEdit(scope.row)"
                type="text"
                size="small"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
    </div>
  </div>
</template>
<script>
import {
  getCheckupSubjectInProjectList,
  getCheckupSubjectHistoryListInProjectList
} from '@/apis/projects'
export default {
  name: "ProjectHistory",
  data() {
    return {
      headerTitle: "陕西省三年行动-项目历史",
       tableData: [
        {
          name: "校园检查表",
        },
        {
          name: "交通安全检查表",
        },
        {
          name: "道路安全检查表",
        },
      ],
      checkup_project_id:''
    };
  },
  mounted(){
    this.checkup_project_id = this.$route.params.id
    getCheckupSubjectHistoryListInProjectList({
      checkup_project_id:this.checkup_project_id
    }).then(res=>{
      this.tableData = res.data.data.checkup_subject_history_list
    })
  },
  methods:{
    goBack(){
      this.$router.back()
    },
    handleEdit(row){
      this.$router.push(`/projectManag/ChecklistEdit/${this.checkup_project_id}-${row.checkup_subject_id}`)
    }
  }
};
</script>
<style scoped>
#ProjectHistory {
  position: relative;
}
.header {
  width: 100%;
  height: 35px !important;
  border-bottom: 1px solid #ccc;
}
.header-left {
  width: 400px;
  text-align: left;
  position: absolute;
}
#ProjectHistory>>>.el-page-header__content {
  font-weight: bold;
  font-size: 18px;
}
.el-table{
  color: #101010;
font-weight: bold;
}
#ProjectHistory >>> .el-table th.el-table__cell > .cell{
    color: #101010;
font-weight: bold;
font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/Orgin/ProjectManag/History/ProjectHistory.vue